<template>
  <div>
    <div
      v-show="!resettingpassword && user_id != 0"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-title">
        <div class="col-12 pt-4 pb-4 bg-primary text-center text-white">
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </div>
      <h4 class="px-3">Reset password</h4>
      <form autocomplete="off" class="px-3 pb-4" @submit.prevent="resetpassword">
        <div class="mb-3">
          <label class="form-label" for="new-password">
            Enter your new password
          </label>
          <input
            id="new-password"
            v-model="i_password"
            autocomplete="off"
            type="password"
            :class="['form-control', i_password_valid === false ? 'is-invalid' : '']"
          />
          <div class="invalid-feedback">
            Password must not be blank and must match the repeat password
          </div>
        </div>
        <div class="mb-4">
          <label class="form-label" for="new-password-repeat">
            Repeat your new password
          </label>
          <input
            id="new-password-repeat"
            v-model="i_password_repeat"
            autocomplete="off"
            type="password"
            :class="['form-control', i_password_repeat_valid === false ? 'is-invalid' : '']"
          />
          <div class="invalid-feedback">
            Repeat password must not be blank and must match the password
          </div>
        </div>
        <div class="col-12 mx-auto text-center">
          <button class="btn btn-primary col-6" type="submit">
            <span class="icon-key me-2" />Update your password
          </button>
        </div>
      </form>
    </div>

    <div v-show="Number(user_id) === 0" class="mx-auto col-6 border-0">
      <div class="alert alert-danger" role="alert">
        The link is incorrect or has expired
      </div>
    </div>

    <div
      v-show="resettingpassword && user_id != 0"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-title">
        <div class="col-12 pt-4 pb-4 bg-primary text-center text-white">
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </div>
      <div class="alert alert-success m-0" role="alert">
        Your password has been reset
        <br><br>
        <button
          class="btn btn-primary col-12 col-sm-6"
          type="button"
          @click.prevent="gotologin"
        >
          <span class="icon-key me-2" />Go to login
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ResetPassword',
  components: {
  },
  data () {
    return {
      token: this.$route.params.t,
      user_id: null,
      i_password: '',
      i_password_valid: true,
      i_password_repeat: '',
      i_password_repeat_valid: true,
      resettingpassword: false,
      passwordhasbeenreset: false,
      message: ''
    }
  },
  mounted () {
    this.getuserid()
  },
  methods: {
    gotologin () {
      this.$router.push('/')
    },
    getuserid () {
      this.$store.dispatch('userbytoken_fetch', { token: this.token })
        .then((resp) => {
          this.user_id = resp.data.i
        })
    },
    resetpassword () {
      let formok = true
      if (this.i_password === '') {
        this.i_password_valid = false
        formok = false
      }
      if (this.i_password_repeat === '') {
        this.i_password_repeat_valid = false
        formok = false
      }
      if (this.i_password !== this.i_password_repeat) {
        this.i_password_valid = false
        this.i_password_repeat_valid = false
        formok = false
      }
      if (formok) {
        this.savefield('i_user', this.user_id, 'i_password', this.i_password)
        this.resettingpassword = true
      }
    },
    savefield (tablename, id, fieldname, value) {
      if (id > 0) {
        const record = {
          id,
          [fieldname]: value,
          token: this.token
        }
        return this.$store.dispatch('resetpassword_save', { user: record })
      }
    }
  }
}
</script>
<style>
</style>
